import React from 'react'

import { Popover, Paper, Typography, Box } from '@material-ui/core'

import { WorkorderTransitionButtons } from '../../../../components/WorkorderStatusTransitionButtons/WorkorderStatusTransitionButtons'
import { BaseWorkorder, User, Company } from '../../../../models'

interface StatusEditPopoverProps {
    open: boolean
    anchorEl: HTMLElement | null
    workorder: BaseWorkorder | null
    user?: User
    activeWorkspace?: Company
    onClose: () => void
    onStatusTransition?: (workorder: BaseWorkorder, newStatus: string) => void
}

export const StatusEditPopover = ({
    open,
    anchorEl,
    onClose,
    workorder,
    user,
    activeWorkspace,
    onStatusTransition,
}: StatusEditPopoverProps) => {
    if (!workorder) return null

    const handleTransition = (
        event: React.MouseEvent<HTMLButtonElement>,
        workorder: BaseWorkorder,
        status: string,
    ) => {
        if (onStatusTransition) {
            onStatusTransition(workorder, status)
        }
        // Don't close the popover - allow multiple transitions
    }

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            PaperProps={{
                style: {
                    padding: '16px',
                    minWidth: '300px',
                },
            }}
        >
            <Paper elevation={0}>
                <Box mb={2}>
                    <Typography variant="h6" gutterBottom>
                        Edit Workorder Status
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        {workorder.service_name} - {workorder.unit_name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Current Status: {workorder.status}
                    </Typography>
                </Box>

                <WorkorderTransitionButtons
                    workorder={workorder}
                    user={user}
                    activeWorkspace={activeWorkspace}
                    handleTransition={handleTransition}
                    style={{
                        justifyContent: 'flex-start',
                        margin: 0,
                        flexDirection: 'column',
                        gap: '8px',
                    }}
                />
            </Paper>
        </Popover>
    )
}
